import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import logo from '../assets/logo.png'

export const PublicNavbar = () => {
  const navigate = useNavigate()

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ gap: 2 }}>
          <Box
            component="img"
            src={logo}
            alt="T&F All-Star Recruiting"
            sx={{ height: 40, width: 40, objectFit: 'contain', cursor: 'pointer' }}
            onClick={() => navigate('/')}
          />
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, fontWeight: 700, cursor: 'pointer' }}
            onClick={() => navigate('/')}
          >
            T&F All-Star Recruiting
          </Typography>
          <Button color="inherit" onClick={() => navigate('/login')} sx={{ fontWeight: 600 }}>
            Log In
          </Button>
          <Button variant="contained" color="warning" onClick={() => navigate('/signup')}>
            Sign Up
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
